/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getUnredactedIssuedCard} from '../api'

 export const useQueryGetUnredactedIssuedCard = createReactQueryHook('getUnredactedIssuedCard', getUnredactedIssuedCard)
